import type { SVGProps } from "react";
export interface GridDotsCenterHrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GridDotsCenterHrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GridDotsCenterHrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M3 19.866c.23 0 .442.07.62.188q.062.042.117.094c.074.065.143.136.198.218a1.12 1.12 0 0 1 0 1.258 1.124 1.124 0 0 1-1.733.166 1.122 1.122 0 0 1 .167-1.729A1.1 1.1 0 0 1 3 19.866m8.997 0c.227 0 .437.07.614.185a1.124 1.124 0 0 1 .185 1.739 1.12 1.12 0 0 1-1.597 0 1.122 1.122 0 0 1 .184-1.739 1.1 1.1 0 0 1 .614-.184Zm8.997 0c.234 0 .452.073.632.195a1.124 1.124 0 0 1 .167 1.729 1.124 1.124 0 0 1-1.733-.165 1.12 1.12 0 0 1-.002-1.259c.055-.082.125-.153.2-.218.037-.033.074-.067.115-.094a1.1 1.1 0 0 1 .621-.188m-13.492.003a1.126 1.126 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0 .114.006a1.126 1.126 0 0 1 0 2.238l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zM1.875 16.5v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.126 1.126 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0M1.875 7.502v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.126 1.126 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0m8.997 0v-.006a1.125 1.125 0 0 1 2.25 0v.006a1.125 1.125 0 0 1-2.25 0M3 1.872c.234 0 .452.073.632.195a1.125 1.125 0 0 1 .307 1.553 1 1 0 0 1-.094.117 1.12 1.12 0 0 1-1.778-.105 1.12 1.12 0 0 1 .138-1.43A1.12 1.12 0 0 1 3 1.872m8.997 0c.235 0 .452.073.632.195a1.125 1.125 0 0 1-.005 1.868 1.12 1.12 0 0 1-1.255 0 1.124 1.124 0 0 1-.003-1.868c.18-.122.397-.195.631-.195m8.997 0c.311 0 .592.126.796.33a1.12 1.12 0 0 1 .137 1.43 1.125 1.125 0 0 1-1.561.303 1.1 1.1 0 0 1-.218-.198q-.05-.055-.094-.117a1.12 1.12 0 0 1 .309-1.553 1.1 1.1 0 0 1 .631-.195m-13.492.003a1.125 1.125 0 0 1 0 2.25h-.006a1.125 1.125 0 0 1 0-2.25zm8.997 0a1.125 1.125 0 0 1 0 2.25h-.006a1.126 1.126 0 0 1 0-2.25zm4.501 9a1.125 1.125 0 0 1 0 2.25H3a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
